import { List, Record } from "immutable";

/** Raw transition rule as stored in the org's `job_states.states` blob. */
export interface IJobStateTransitionData {
  from: string | string[];
  to: string;
  on: string;
}

export interface IJobStateTransitionRecord {
  from: List<string>;
  to: string;
  on: string;
}

export const defaultJobStateTransitionRecord = {
  from: List<string>(),
  to: "",
  on: "",
};

export class JobStateTransitionRecord
  extends Record(defaultJobStateTransitionRecord)
  implements IJobStateTransitionRecord {}

const normalizeFrom = (from: IJobStateTransitionData["from"]): List<string> =>
  List<string>(Array.isArray(from) ? from : from == null ? [] : [from]);

export const jobStateTransitionFromJSON = (json: Partial<IJobStateTransitionData>): JobStateTransitionRecord =>
  new JobStateTransitionRecord({
    from: normalizeFrom(json.from ?? []),
    to: json.to ?? "",
    on: json.on ?? "",
  });
